/** Build-time gate: password reset UI/API (requires outbound email on backend). */
export function isPasswordResetEnabled(): boolean {
  return import.meta.env.VITE_PASSWORD_RESET_ENABLED === "true";
}
